<h1 mat-dialog-title>{{TitleText}}</h1>
<div mat-dialog-content>
    <form [formGroup]="checkboxDialogForm">
        <p [innerHtml]="MessageText"></p>
        <mat-checkbox formControlName="CheckboxOption" aria-label="Checkbox input option">{{CheckboxLabel}}
        </mat-checkbox>
    </form>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button color="warn" (click)="CancelHandler()">Cancel</button>
    <button mat-raised-button color="primary" (click)="OKHandler()">OK</button>
</div>